// Internal modules
import { isTest } from '../utils/env';
import { resolveFeatures } from './resolvers';

const features = {
  allActive(...feats) {
    return Boolean(feats.length) && feats.every(f => this.config[f]);
  },
  allNotActive(...feats) {
    return !feats.length || feats.every(f => !this.config[f]);
  },

  config: resolveFeatures(),

  get(name) {
    return this.config[name];
  },

  isActive(feat) {
    return this.config[feat] === true;
  },
  isNotActive(feat) {
    return !this.isActive(feat);
  },

  someActive(...feats) {
    return !this.allNotActive(...feats);
  },
  someNotActive(...feats) {
    return !this.allActive(...feats);
  },
};

if (isTest) {
  features.set = feats => {
    features.config = {
      ...features.config,
      ...feats,
    };
  };
}

export { features, resolveFeatures };
